import type { PostcardDesignOption } from '~~/layers/postcard/app/types'

type ParagraphDesign = {
  id?: string | null
  text?: string | null
  imageUrl?: string | null
  imageAlt?: string | null
  previewImageUrl?: string | null
  previewImageAlt?: string | null
} | null

/**
 * Maps GraphQL postcard designs to options used by the overlay.
 *
 * `imageUrl` (print asset) is required and sent to Swiss Post.
 * `previewImageUrl` is optional and only used in the design picker UI.
 */
export function mapParagraphPostcardDesigns(
  designs?: Array<ParagraphDesign> | null,
): PostcardDesignOption[] {
  if (!designs?.length) {
    return []
  }

  return designs
    .filter(
      (
        design,
      ): design is NonNullable<ParagraphDesign> & {
        id: string
        imageUrl: string
      } => Boolean(design?.id && design.imageUrl),
    )
    .map((design) => ({
      id: design.id,
      text: design.text ?? undefined,
      imageUrl: design.imageUrl,
      imageAlt: design.imageAlt ?? undefined,
      previewImageUrl: design.previewImageUrl ?? undefined,
      previewImageAlt: design.previewImageAlt ?? undefined,
    }))
}
